import { useEffect } from "react";
import { useColorMode } from "@chakra-ui/react";
import { INIT_COLOR_MODE } from "@/lib/chakra/theme";
import { useAppSelector } from "@/lib/hooks";

type Props = {
  children: React.ReactNode;
};

export const AppColorsWrapper = ({ children }: Props) => {
  const { setColorMode } = useColorMode();
  const { clientType } = useAppSelector((state) => state.app);

  useEffect(() => {
    if (!clientType) return;
    const initial = INIT_COLOR_MODE[clientType];
    if (initial === "dark" || initial === "light") {
      setColorMode(initial);
    }
  }, [clientType, setColorMode]);

  return children;
};
